import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "007_backfill_purchase_invoice_numbers",
  version: "1.3.2",
  ignoreErrors: ["no such table: accounting_invoices"],
  sql: `
WITH candidates AS (
  SELECT
    \`id\`,
    COALESCE(NULLIF(substr(\`invoice_date\`, 1, 4), ''), strftime('%Y', 'now')) AS doc_year,
    \`invoice_date\`,
    \`created_at\`
  FROM \`purchase_invoices\`
  WHERE \`invoice_type\` = 'purchase'
    AND (\`invoice_no\` NOT LIKE 'PINV-%' OR length(\`invoice_no\`) <> 15)
),
existing AS (
  SELECT
    doc_year,
    MAX(seq) AS max_seq
  FROM (
    SELECT
      substr(\`invoice_no\`, 6, 4) AS doc_year,
      CAST(substr(\`invoice_no\`, 11) AS INTEGER) AS seq
    FROM \`purchase_invoices\`
    WHERE \`invoice_type\` = 'purchase'
      AND \`invoice_no\` LIKE 'PINV-%'
      AND length(\`invoice_no\`) = 15
    UNION ALL
    SELECT
      substr(\`invoice_no\`, 6, 4) AS doc_year,
      CAST(substr(\`invoice_no\`, 11) AS INTEGER) AS seq
    FROM \`accounting_invoices\`
    WHERE \`invoice_type\` = 'purchase'
      AND \`invoice_no\` LIKE 'PINV-%'
      AND length(\`invoice_no\`) = 15
  )
  GROUP BY doc_year
),
numbered AS (
  SELECT
    candidates.\`id\`,
    'PINV-' || candidates.doc_year || '-' || printf(
      '%05d',
      COALESCE(existing.max_seq, 0)
        + ROW_NUMBER() OVER (
          PARTITION BY candidates.doc_year
          ORDER BY candidates.\`invoice_date\`, candidates.\`created_at\`, candidates.\`id\`
        )
    ) AS new_invoice_no
  FROM candidates
  LEFT JOIN existing ON existing.doc_year = candidates.doc_year
)
UPDATE \`accounting_invoices\`
SET
  \`invoice_no\` = (SELECT numbered.new_invoice_no FROM numbered WHERE numbered.\`id\` = \`accounting_invoices\`.\`id\`),
  \`updated_at\` = strftime('%Y-%m-%dT%H:%M:%fZ', 'now')
WHERE \`id\` IN (SELECT \`id\` FROM numbered);

UPDATE \`purchase_invoices\`
SET
  \`invoice_no\` = (
    SELECT \`accounting_invoices\`.\`invoice_no\`
    FROM \`accounting_invoices\`
    WHERE \`accounting_invoices\`.\`id\` = \`purchase_invoices\`.\`id\`
  ),
  \`updated_at\` = strftime('%Y-%m-%dT%H:%M:%fZ', 'now')
WHERE \`id\` IN (
  SELECT \`id\`
  FROM \`accounting_invoices\`
  WHERE \`invoice_type\` = 'purchase'
    AND \`invoice_no\` LIKE 'PINV-%'
    AND length(\`invoice_no\`) = 15
);

WITH current_year_max AS (
  SELECT COALESCE(MAX(CAST(substr(\`invoice_no\`, 11) AS INTEGER)), 0) AS max_seq
  FROM \`purchase_invoices\`
  WHERE \`invoice_type\` = 'purchase'
    AND substr(\`invoice_no\`, 6, 4) = strftime('%Y', 'now')
    AND \`invoice_no\` LIKE 'PINV-%'
    AND length(\`invoice_no\`) = 15
)
UPDATE \`core_numbering_series\`
SET
  \`prefix\` = CASE
    WHEN \`prefix\` LIKE 'INV-%' THEN 'PINV-{YYYY}-#####'
    ELSE \`prefix\`
  END,
  \`current_value\` = (SELECT max_seq FROM current_year_max),
  \`reset_every\` = 'yearly',
  \`last_reset_year\` = CAST(strftime('%Y', 'now') AS INTEGER),
  \`updated_at\` = strftime('%Y-%m-%dT%H:%M:%fZ', 'now')
WHERE \`module\` = 'purchase'
  AND \`doctype\` = 'purchase_invoice'
  AND \`is_default\` = 1
  AND ((SELECT max_seq FROM current_year_max) > 0 OR \`prefix\` LIKE 'INV-%');
  `.trim(),
};
